import React, { useCallback } from "react"
import classNames from "classnames"
import { Icon } from "@blueprintjs/core"
import { useTranslation } from "react-i18next"
import type { TFunction } from "i18next"

// Group names double as ids in the chat list (collapsed groups, sorting), so
// they are only translated here, when shown. Product names and dispatcher
// names pass through.
export const chatGroupLabel = (t: TFunction, name: string): string => {
  switch (name) {
    case "Groups":
      return t("app.chatList.groups.groups")
    case "Drivers":
      return t("app.chatList.groups.drivers")
    case "Shared Drivers":
      return t("app.chatList.groups.sharedDrivers")
    case "Whatsapp Contacts":
      return t("app.chatList.groups.whatsappContacts")
    case "Double Crew":
      return t("app.chatList.groups.doubleCrew")
    default:
      return name
  }
}

type ChatListGroupHeaderProps = {
  name: string
  count: number
  isCollapsed: boolean
  onToggle: (name: string) => void
  filterValue: string
}

const ChatListGroupHeader = ({
  name,
  count,
  isCollapsed,
  onToggle,
  filterValue,
}: ChatListGroupHeaderProps) => {
  const { t } = useTranslation()
  const handleClick = useCallback(() => {
    onToggle(name)
  }, [onToggle, name])
  return (
    <div
      className={classNames(
        "align-center flex select-none scroll-m-12 flex-row gap-1 p-3 text-xs font-medium",
        { "cursor-pointer": !filterValue },
      )}
      onClick={handleClick}
    >
      <div className="flex-grow">{chatGroupLabel(t, name)}</div>
      {count > 0 && isCollapsed && (
        <div className="flex h-5 min-w-5 items-center justify-center rounded-lg bg-base-primary p-1 text-xs font-semibold tabular-nums text-white dark:bg-blue-500 dark:text-black">
          {count}
        </div>
      )}
      <div>
        <Icon
          size={16}
          icon={!filterValue && isCollapsed ? "chevron-right" : "chevron-down"}
        />
      </div>
    </div>
  )
}

export default React.memo(ChatListGroupHeader)
